module.exports = __webpack_public_path__ + "static/media/informacao.a1505958.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Svg/informacao.svg
// module id = 433
// module chunks = 0